import React from "react";
import { Box, useTheme } from "@mui/material";
import Eyebrow from "./Eyebrow";
import { fonts } from "../../theme/tokens";

/**
 * Dashboard-style KPI: small uppercase label, serif number, optional coloured subline.
 * Optional `active` highlights the tile when it represents the current filter.
 */
export default function KpiTile({ label, value, sub, tone, onClick, active = false }) {
  const theme = useTheme();
  const subColor =
    tone === "warning"
      ? theme.palette.brand.goldDeep
      : tone === "danger"
        ? theme.palette.error.main
        : tone === "success"
          ? theme.palette.success.main
          : theme.palette.brand.inkSoft;

  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${active ? theme.palette.brand.black : theme.palette.brand.border}`,
        borderRadius: "8px",
        p: "16px 18px",
        cursor: onClick ? "pointer" : "default",
        transition: "border-color .12s, background .12s",
        ...(active
          ? { backgroundColor: theme.palette.brand.surfaceMuted }
          : {}),
        "&:hover": onClick
          ? {
              borderColor: theme.palette.brand.borderStrong,
              backgroundColor: theme.palette.brand.surface,
            }
          : {},
      }}
    >
      <Eyebrow sx={{ color: theme.palette.brand.inkSoft, fontSize: 10, mb: 1.25 }}>
        {label}
      </Eyebrow>
      <Box
        sx={{
          fontFamily: fonts.serif,
          fontSize: 36,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: "-0.02em",
          color: theme.palette.brand.ink,
        }}
      >
        {value}
      </Box>
      <Box sx={{ fontSize: 12, color: subColor, mt: 1, fontWeight: 500 }}>{sub}</Box>
    </Box>
  );
}
